export class CommentTemplate {

    Id: number;
    SectionId: number;
    TemplateText: string;

    constructor() {
    }
}